import { BaseComponent } from '../../base-component';
import {
    articleInfoTeaserVariationChange,
    articleTeaserVariationChange,
    pointsTeaserVariationChange,
} from '@otto-ec/nexus-registry/promo/up/teaser';

export class UpInfoComponent extends BaseComponent {
    public rootSelector = '.js_pdp_up-info';
    public static shippingCostsProgressBarSelector = '.js_pdp_up-info__shipping-costs-progress-bar'; /*                                                 */
    private redesignVisibilityObserver?: MutationObserver;

    public async init(): Promise<void> {
        return;
    }

    public async onHtmlLoaded(): Promise<void> {
        if (!this.isPresent()) {
            return;
        }
        const variationId = this.getRootElement().dataset.variationId || '';

        if (this.usesOnExNewDesign()) {
            this.sendArticleInfoTeaserTargetEvent(variationId);
            this.setupRedesignVisibility();
            return;
        }

        this.sendUpTeaserTargetEvent(variationId);
        this.sendUpPointsBannerTargetEvent(variationId);
    }

    private usesOnExNewDesign(): boolean {
        return (
            !!this.getRootElement().querySelector('.js_pdp_up-info__up-teaser-target') &&
            !this.getRootElement().querySelector('.js_pdp_up-info__up-points-banner-target')
        );
    }

    private sendUpTeaserTargetEvent(variationId: string): void {
        const targetElementBottom = this.getChildElement('.js_pdp_up-info__up-teaser-target');
        articleTeaserVariationChange({
            variationId,
            targetElement: targetElementBottom,
            cdc: false,
        });
    }

    private sendUpPointsBannerTargetEvent(variationId: string): void {
        const targetElement = this.getChildElement('.js_pdp_up-info__up-points-banner-target');
        pointsTeaserVariationChange({
            variationId,
            targetElement: targetElement,
            cdc: false,
        });
    }

    private sendArticleInfoTeaserTargetEvent(variationId: string): void {
        const targetElement = this.getChildElement('.js_pdp_up-info__up-teaser-target');
        articleInfoTeaserVariationChange({
            variationId,
            targetElement,
            cdc: false,
        });
    }

    private setupRedesignVisibility(): void {
        const rootElement = this.getRootElement();
        const sectionElements = [
            ...this.getChildElements<HTMLElement>('.js_pdp_up-info__shipping-costs-progress-bar'),
            ...this.getChildElements<HTMLElement>('.js_pdp_up-info__up-teaser-target'),
        ];
        const dividerElement = rootElement.querySelector<HTMLElement>('.js_pdp_up-info__divider');
        const blockElement = rootElement.querySelector<HTMLElement>('.js_pdp_up-info__block');
        const usesStackedBlock = !!blockElement;

        const updateVisibility = () => {
            const visibleSections = sectionElements.filter(section => {
                const hasContent = this.hasVisibleContent(section);
                section.classList.toggle('pdp_up-info__section--hidden', !hasContent);
                return hasContent;
            });
            const hasVisibleSections = visibleSections.length > 0;

            rootElement.classList.toggle('pdp_up-info--hidden', !hasVisibleSections);

            if (usesStackedBlock) {
                blockElement?.classList.toggle('pdp_up-info__block--hidden', !hasVisibleSections);
                dividerElement?.classList.toggle('pdp_up-info__divider--hidden', visibleSections.length < 2);
            }
        };

        updateVisibility();

        this.redesignVisibilityObserver?.disconnect();
        this.redesignVisibilityObserver = new MutationObserver(updateVisibility);

        for (const sectionElement of sectionElements) {
            this.redesignVisibilityObserver.observe(sectionElement, {
                childList: true,
                subtree: true,
                attributes: true,
                characterData: true,
            });
        }
    }

    private hasVisibleContent(element: HTMLElement): boolean {
        const textContent = element.textContent?.replace(/\s+/g, '').trim() ?? '';
        return element.children.length > 0 || textContent.length > 0;
    }
}
